export const Selected = "Selected:";
export const OnHold = "On Hold:";
export const Failed = "Failed:";
export const StaffInterviewGraph = "Staff Interview Graph";
export const Duration = "duration";
export const SelectDuration = "Select Duration";
export const SalesDashboardTitle = "Sales Dashboard";
export const SalesDashboardSubTitle = "Overview of sales performance";
export const InterviewCount = "Interview Count";
export const TechnologyGraph = "Technology Graph";
